export default "__VITE_ASSET__245e61e6__"